import type { SxProps, Theme } from '@mui/material';

import { DEFAULT_THUMBNAIL_CARD_SIZE } from 'components/common/graphicUploader/styles';

/** Vertical spacing between comment / attachments / issues blocks. */
export const protocolItemSectionsStackSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};

export const rootSx: SxProps<Theme> = protocolItemSectionsStackSx;

export const protocolItemSectionSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  width: '100%',
};

/** Empty-state add tile of the attachments gallery (compact = half a tile). */
export const ISSUE_ADD_TILE_SIZE_PX = Math.round(DEFAULT_THUMBNAIL_CARD_SIZE / 2);
/** A full attachments tile: the add tile next to the issue tiles. */
export const ISSUE_ADD_TILE_MAX_SIZE_PX = DEFAULT_THUMBNAIL_CARD_SIZE;

/** Narrowest column that still fits one square issue tile. */
const SECONDARY_COLUMN_MIN_WIDTH_PX = DEFAULT_THUMBNAIL_CARD_SIZE;

/**
 * Attachments and issues side by side. Sized by the row's own width, not the
 * viewport, so a narrow row (or a single visible column) stacks / fills.
 */
export const secondaryColumnsSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fit, minmax(min(${SECONDARY_COLUMN_MIN_WIDTH_PX}px, 100%), 1fr))`,
  columnGap: 3,
  rowGap: 2,
  alignItems: 'start',
  width: '100%',
};

/**
 * Add tile first, then the square issue tiles, laid out exactly like the
 * attachments gallery's `ImageList`: same auto-fill grid template and 16px
 * gap, so leftover width is spread between tiles the same way in both columns.
 */
export const issuesListSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fill, minmax(${DEFAULT_THUMBNAIL_CARD_SIZE}px, 1fr))`,
  gap: 2,
  alignItems: 'start',
  justifyItems: 'start',
  width: '100%',
};

export const issueCardSlotSx: SxProps<Theme> = {
  width: DEFAULT_THUMBNAIL_CARD_SIZE,
  height: DEFAULT_THUMBNAIL_CARD_SIZE,
  flexShrink: 0,
};

export const issueCardLoadingSlotSx: SxProps<Theme> = {
  ...issueCardSlotSx,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
